import {EventEmitter, Injectable, signal, WritableSignal} from '@angular/core';
import {takeUntilDestroyed, toObservable, toSignal} from '@angular/core/rxjs-interop';
import {EControlActions} from 'frontier/nucleus';
import {BehaviorSubject, filter, Subject} from 'rxjs';

export interface IControlDataChanged {
  GUID: string;
  changeType: EControlActions;
}

@Injectable({
  providedIn: 'root'
})
export class ControlStore {

  controlDataChanged$ = new EventEmitter<IControlDataChanged>();
  controlDataChangedSignal = toSignal(this.controlDataChanged$);
  tenant: WritableSignal<string> = signal(localStorage.getItem('tenant') || null);
  tenant$ = toObservable(this.tenant);
  tenantChanged$ = new Subject<string>();
  setTenant$ = new BehaviorSubject<string>(this.tenant())


  constructor() {
    this.setTenant$
      .pipe(
        takeUntilDestroyed(),
        filter(tenant => tenant !== this.tenant())
      )
      .subscribe(tenant => {
        this.tenant.set(tenant);
        this.tenantChanged$.next(tenant);
        localStorage.setItem('tenant', JSON.stringify(tenant));
      })
  }
}
